import toast from "react-hot-toast";
import type { GMOPGErrorInfo } from "../../libs/connect";
import { t } from "../../libs/i18n";

type GMOPGErrorToastOptions = {
  fallbackMessage?: string;
};

export function showGMOPGErrorToast(
  error: GMOPGErrorInfo,
  options: GMOPGErrorToastOptions = {},
) {
  toast.error(formatGMOPGErrorToastMessage(error, options));
}

export function formatGMOPGErrorToastMessage(
  error: GMOPGErrorInfo,
  options: GMOPGErrorToastOptions = {},
) {
  if (isUnsupported3DSecureCardError(error)) {
    return t("このカードはご利用いただけません。別のカードをお試しください。");
  }

  const detail = error.detail ? `\n${error.detail}` : "";
  const status = error.status ? `\n[${error.status}]` : "";
  return `${options.fallbackMessage ?? t("決済サービスとの通信に失敗しました")} ${detail}${status}`;
}

function isUnsupported3DSecureCardError(error: GMOPGErrorInfo) {
  return (
    error.status === "402" &&
    error.detail?.toLowerCase().includes("3d secure authentication failed")
  );
}
